import { Component, OnInit } from '@angular/core';
import { ServerTokenService } from '../../services/server-token.service';

@Component({
  selector: 'ngx-user-action-log',
  templateUrl: './user-action-log.component.html',
  styleUrls: ['./user-action-log.component.scss']
})
export class UserActionLogComponent implements OnInit {

  selectedUser;
  users: {email: string, privateName: string}[] = [];
  data: {
    "_id": "66c62a85d6f27922cc8c6063",
    "actionType": "/snfs/updateUserRead",
    "actionTime": Date,// new Date("2024-08-21T17:57:25.218Z"),
    "requestBody": {
        "referalId": "38670172"
    },
    "responseStatus": 200,
    "displayAction": "Patient Details"
}[]

  constructor(private server: ServerTokenService) { }


  ngOnInit(): void {
    this.server.postWithToken('snfs/admin/getUserByCompany', {companyName: 'Empire Care Centers'}).subscribe(data => {
      this.users = data as any;
    });
  }
  
  getUserActionLog() {    
    console.log(this.selectedUser)
    this.data = [];
    this.server.postWithToken('snfs/admin/getLastActionsByUser', {userName: this.selectedUser.email}).subscribe(data => {
      console.log(data);
      this.data = data as any;
    });
  }
}
